import { Autocomplete } from "@mui/material";
import { Component } from "react";
import { AppContext } from "../../common/AppContext";
import { ReactComponent as DropIcon } from "../../resources/images/icons-chevron-double.svg";
import { ReactComponent as RemoveIcon } from "../../resources/images/icons-remove.svg";
import { TextField } from "../TextField";

export class MultipleFilter extends Component<any, any> {
  static contextType = AppContext;

  static defaultProps = {
    listType: "Filter",
    maxResults: 50,
    initialSearch: false,
    multiple: true,
    clearable: true,
    hasNoneItem: false,
    noneItemLabel: "None",
    hasAllItem: false,
    allItemLabel: "All",
    getItemId: null,
    debounce: true,
    clearOnSelection: false,
    clearResultsOnSelection: false,
    noOptionsText: "No search results",
    excludeItems: [],
    matchFrom: "any" //start or any
  };

  initialItems: any;
  value: any;
  debounceLoadItems: any;
  dataList: any;

  constructor(props: any) {
    super(props);
  }

  onChange(e: any, selected: any) {
    const { onChange } = this.props;

    onChange(e, selected);
  }

  render() {
    const {
      label,
      sx,
      placeholder,
      focusPlaceholder,
      multiple,
      clearable,
      disabled,
      loading,
      noOptionsText,
      value,
      options,
      getItemLabel,
      filterOptions,
      renderOption
    } = this.props;

    return (
      <Autocomplete
        className='klayo-filterselector klayo-selector'
        options={options}
        value={value}
        getOptionLabel={getItemLabel}
        filterOptions={filterOptions}
        autoComplete
        disableClearable={!clearable}
        filterSelectedOptions
        popupIcon={<DropIcon />}
        clearIcon={<RemoveIcon />}
        noOptionsText={noOptionsText}
        multiple={multiple}
        renderOption={renderOption}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            disabled={disabled}
            loading={loading}
            placeholder={placeholder}
            focusPlaceholder={focusPlaceholder}
            sx={{ width: "100%" }}
            endAdornment={params.InputProps.endAdornment}
          />
        )}
        onChange={this.onChange.bind(this)}
        sx={sx}
      />
    );
  }
}
